import script from "./WorkspacePhasesTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkspacePhasesTab.vue?vue&type=script&setup=true&lang=ts"

import "./WorkspacePhasesTab.vue?vue&type=style&index=0&id=0fcdea5a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fcdea5a"]])

export default __exports__